"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _CryptoNavItemsComponent = _interopRequireDefault(require("./CryptoNavItemsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openSendReceiveSidePane: function openSendReceiveSidePane(isSend, product) {
      dispatch((0, _sidePaneActions.openRetailSendReceiveSidePane)(isSend, product));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_CryptoNavItemsComponent["default"]);